/**
 * Research consent sheet: show Yes/No in Excel instead of TRUE/FALSE or raw yes/no.
 */

/** Flattened row keys for consent questionnaire fields (pre-column relabel). */
const CONSENT_YES_NO_KEYS = new Set([
  'enrollmentResearchConsentAccepted',
  'consentSupplementQuestionnaireSkipped',
  'audioTapedPermission',
  'videoTapedPermission',
  'wishRemainAnonymous',
  'wishAnonymousWithPseudonym',
  'quoteWithNamePermission',
  'receiveStudySummary',
  'followUpInterviewInterest',
]);

/**
 * @param {unknown} value
 * @returns {'Yes' | 'No' | undefined}
 */
export function exportValueToYesNo(value) {
  if (value === true || value === 'true') return 'Yes';
  if (value === false || value === 'false') return 'No';
  if (value === null || value === undefined || value === '') return undefined;
  if (typeof value === 'string') {
    const lower = value.trim().toLowerCase();
    if (lower === 'yes') return 'Yes';
    if (lower === 'no') return 'No';
  }
  return undefined;
}

/**
 * @param {Record<string, string | number | boolean>} row - flattened row (pre-column relabel)
 * @returns {Record<string, string | number | boolean>}
 */
export function decodeResearchConsentFlatRow(row) {
  const out = { ...row };
  for (const key of CONSENT_YES_NO_KEYS) {
    if (!(key in out)) continue;
    const converted = exportValueToYesNo(out[key]);
    if (converted !== undefined) {
      out[key] = converted;
    } else if (typeof out[key] === 'boolean') {
      out[key] = out[key] ? 'Yes' : 'No';
    }
  }
  return out;
}
